import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import ValidateFileGql from '@/store/graphql/cms/queries/ValidateFile.gql';
// import FileGql from '@/store/graphql/cms/queries/File.gql';
// import FilesGql from '@/store/graphql/cms/queries/Files.gql'
import TagsGql from '@/store/graphql/cms/queries/FileTags.gql';
import FilesPaginatedGql from '@/store/graphql/cms/queries/FilesPaginated.gql';
import FilesPaginatedFullGql from '@/store/graphql/cms/queries/FilesPaginatedFull.gql';
import CreateFileGql from '@/store/graphql/cms/mutations/CreateFile.gql';
import UpdateFileGql from '@/store/graphql/cms/mutations/UpdateFile.gql';
import DeleteFileGql from '@/store/graphql/cms/mutations/DeleteFile.gql';
import ChangeFileVisibilityGql from '@/store/graphql/cms/mutations/ChangeFileVisibility.gql';
import ProcessFilePaginationBulkActionGql from '@/store/graphql/cms/mutations/ProcessFilePaginationBulkAction.gql';

export default {
    validate: (name, path, cmsID = null, excludedFileID = null) =>
        new Promise((resolve, reject) => {
            let variables = { name, path };
            if (cmsID) variables.cms = parseInt(cmsID);
            if (excludedFileID) variables.excludedFile = parseInt(excludedFileID);

            apolloClient
                .query({
                    query: ValidateFileGql,
                    variables
                    // fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.ValidateFile))
                .catch(err => reject(err));
        }),
    // fetchList: (shopID = null) => new Promise((resolve, reject) => {
    //
    //     let variables = {}
    //     if (shopID) variables.shop = shopID
    //
    //     apolloClient.query({
    //         query: FilesGql,
    //         variables
    //     })
    //         .then(({data}) => resolve(data.Files))
    //         .catch(err => reject(err))
    // }),
    fetchTagList: (cmsID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: TagsGql,
                    variables
                })
                .then(({ data }) => resolve(data.FileTags))
                .catch(err => reject(err));
        }),
    fetchFilesPaginated: (data, { full = false } = {}) =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: full ? FilesPaginatedFullGql : FilesPaginatedGql,
                    variables: {
                        scope: _.get(data, 'scope', 'base'),
                        type: _.get(data, 'type', 'file'),
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'created_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        link: _.get(data, 'link.route', '/file/'),
                        // Sent so the server can resolve "everything except these" and
                        // echo back a real total for the bulk-action bar.
                        // The selection round-trips: the response echoes it back into the
                        // store carrying __typename, which BulkSelectionInput rejects.
                        selection: _.removeDeepByKey(_.get(data, 'pageInfo.selection'), '__typename'),
                        filters
                    },
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.FilesPaginated))
                .catch(err => reject(err));
        }),
    // fetchFile: (id, cmsID = null) => {
    //     if (id === undefined) throw new Error('required argument is missing');
    //
    //     return new Promise((resolve, reject) => {
    //         apolloClient
    //             .query({
    //                 query: FileGql,
    //                 variables: { id, cms: cmsID }
    //             })
    //             .then(({ data }) => resolve(data.File))
    //             .catch(err => reject(err));
    //     });
    // },
    create: file => {
        if (file === undefined) throw new Error('required argument is missing');

        file = _.removeDeepByKey(file, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateFileGql,
                    variables: { file }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CreateFile);
                })
                .catch(err => reject(err));
        });
    },
    // Bulk actions over a media-library selection. Takes the same selection contract as
    // the paginated query, so "everything matching these filters" is one request.
    processPaginationBulkAction: variables =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: ProcessFilePaginationBulkActionGql,
                    variables: _.removeDeepByKey(variables, '__typename'),
                })
                .then(({ data }) => resolve(data.ProcessFilePaginationBulkAction))
                .catch(err => reject(err));
        }),
    update: file => {
        if (file === undefined) throw new Error('required argument is missing');

        file = _.removeDeepByKey(file, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateFileGql,
                    variables: { file }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.UpdateFile);
                })
                .catch(err => reject(err));
        });
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteFileGql,
                    variables: { id: parseInt(id) }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.DeleteFile);
                })
                .catch(err => reject(err));
        });
    },
    noDeleteDialog: (value) => {
        if (value !== undefined) {
            localStorage.setItem('no-delete-dialog:file', value);
        } else {
            return localStorage.getItem('no-delete-dialog:file');
        }
    },
    changeFileVisibility: input => {

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: ChangeFileVisibilityGql,
                    variables: input
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data);
                })
                .catch(err => reject(err));
        });
    }
};
